import { render, staticRenderFns } from "./pharmacy_stock_value.vue?vue&type=template&id=31a142ba&"
import script from "./pharmacy_stock_value.vue?vue&type=script&lang=js&"
export * from "./pharmacy_stock_value.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports